import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';

const empty = {
  event_id: '', organization_id: '', category_id: '', full_name_ar: '', full_name_en: '',
  gender: 'male', date_of_birth: '', nationality: '', national_id: '', passport_no: '',
  passport_expiry: '', job_title: '', email: '', phone: '', emergency_contact_name: '',
  emergency_contact_phone: '', notes: ''
};

export default function RegisterParticipant() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const presetEventId = searchParams.get('event') || '';

  const [form, setForm] = useState({ ...empty, event_id: presetEventId });
  const [photo, setPhoto] = useState(null);
  const [events, setEvents] = useState([]);
  const [presetEvent, setPresetEvent] = useState(null);
  const [orgs, setOrgs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (presetEventId) {
      client.get(`/events/${presetEventId}`).then(r => setPresetEvent(r.data)).catch(() => {});
    } else {
      client.get('/events').then(r => setEvents(r.data)).catch(() => {});
    }
    client.get('/categories').then(r => setCategories(r.data)).catch(() => {});
    if (user.role === 'admin') client.get('/organizations').then(r => setOrgs(r.data)).catch(() => {});
  }, [presetEventId, user.role]);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setMsg(null); setLoading(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v !== '') fd.append(k, v); });
      if (photo) fd.append('photo', photo);
      await client.post('/participants', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setMsg('تم تسجيل المشارك بنجاح وإرساله للمراجعة');
      setForm({ ...empty, event_id: presetEventId });
      setPhoto(null);
      e.target.reset();
      if (presetEventId) setTimeout(() => navigate(`/events/${presetEventId}`), 1200);
    } catch (err) {
      setError(err.response?.data?.message || 'حدث خطأ أثناء التسجيل');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      {presetEventId && (
        <button className="btn btn-outline" style={{ marginBottom: 14 }} onClick={() => navigate(`/events/${presetEventId}`)}>← رجوع للفعالية</button>
      )}
      <h2 style={{ marginTop: 0 }}>تسجيل المشاركين{presetEvent ? ` — ${presetEvent.name_ar}` : ''}</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <form onSubmit={submit}>
        <div className="form-grid">
          {!presetEventId && (
            <div className="form-field">
              <label>الفعالية *</label>
              <select name="event_id" value={form.event_id} onChange={onChange} required>
                <option value="">اختر الفعالية</option>
                {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name_ar}</option>)}
              </select>
            </div>
          )}

          {user.role === 'admin' && (
            <div className="form-field">
              <label>الجهة / الاتحاد *</label>
              <select name="organization_id" value={form.organization_id} onChange={onChange} required>
                <option value="">اختر الجهة</option>
                {orgs.map(o => <option key={o.id} value={o.id}>{o.name_ar}</option>)}
              </select>
            </div>
          )}

          <div className="form-field">
            <label>فئة الاعتماد *</label>
            <select name="category_id" value={form.category_id} onChange={onChange} required>
              <option value="">اختر الفئة</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name_ar}</option>)}
            </select>
          </div>

          <div className="form-field">
            <label>الاسم الكامل (عربي) *</label>
            <input name="full_name_ar" value={form.full_name_ar} onChange={onChange} required />
          </div>
          <div className="form-field">
            <label>الاسم الكامل (English)</label>
            <input name="full_name_en" value={form.full_name_en} onChange={onChange} />
          </div>

          <div className="form-field">
            <label>الجنس *</label>
            <select name="gender" value={form.gender} onChange={onChange} required>
              <option value="male">ذكر</option>
              <option value="female">أنثى</option>
            </select>
          </div>

          <div className="form-field">
            <label>تاريخ الميلاد</label>
            <input type="date" name="date_of_birth" value={form.date_of_birth} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>الجنسية</label>
            <input name="nationality" value={form.nationality} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>رقم الهوية الوطنية</label>
            <input name="national_id" value={form.national_id} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>رقم جواز السفر</label>
            <input name="passport_no" value={form.passport_no} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>تاريخ انتهاء الجواز</label>
            <input type="date" name="passport_expiry" value={form.passport_expiry} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>الصفة الوظيفية</label>
            <input name="job_title" value={form.job_title} onChange={onChange} placeholder="مثال: لاعب، مدرب، حكم..." />
          </div>
          <div className="form-field">
            <label>البريد الإلكتروني</label>
            <input type="email" name="email" value={form.email} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>رقم الهاتف</label>
            <input name="phone" value={form.phone} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>جهة الاتصال في الطوارئ</label>
            <input name="emergency_contact_name" value={form.emergency_contact_name} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>هاتف الطوارئ</label>
            <input name="emergency_contact_phone" value={form.emergency_contact_phone} onChange={onChange} />
          </div>
          <div className="form-field">
            <label>الصورة الشخصية</label>
            <input type="file" accept="image/*" onChange={e => setPhoto(e.target.files[0])} />
          </div>
        </div>

        <div className="form-field" style={{ marginTop: 14 }}>
          <label>ملاحظات</label>
          <textarea name="notes" rows="3" value={form.notes} onChange={onChange} />
        </div>

        <button className="btn btn-primary" style={{ marginTop: 18 }} disabled={loading}>
          {loading ? 'جارٍ الحفظ...' : 'حفظ وإرسال للمراجعة'}
        </button>
      </form>
    </div>
  );
}
